// Meta Pixel helper — centralizes Facebook Pixel init and event tracking.
// Pixel ID: 962279486187488

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '962279486187488'
const PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js'
let initialized = false

/**
 * Injects the Meta Pixel script (idempotent) and fires the initial PageView.
 * Safe to call multiple times — only initializes once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized) return
  initialized = true

  // Bootstrap fbq stub (translated from the official Meta snippet, but
  // without the fragile getElementsByTagName('script')[0] insertion — in a
  // bundled React app there is no guarantee a <script> tag exists in the DOM
  // at this point, which crashed with "reading 'parentNode' of undefined").
  const w = window as any
  if (!w.fbq) {
    const n: any = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod
        ? n.callMethod.apply(n, arguments as any)
        : n.queue.push(arguments)
    }
    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Append the pixel script to <head> (falls back to <body> if needed).
    const script = document.createElement('script')
    script.async = true
    script.src = PIXEL_SRC
    const parent = document.head || document.body || document.documentElement
    parent.appendChild(script)
  }

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')

  // <noscript> fallback pixel for users without JS
  if (document.body) {
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }
}

/**
 * Fires a Meta Pixel standard or custom event.
 */
export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}

/**
 * Fires the AddToCart standard event and then runs the redirect.
 * A small delay gives the pixel time to send the network request before
 * the page is unloaded.
 */
export function trackAddToCartAndRedirect(
  url: string,
  params?: Record<string, unknown>,
): void {
  trackEvent('AddToCart', params)
  // Give the pixel ~250ms to fire before navigation
  window.setTimeout(() => {
    window.location.href = url
  }, 250)
}
